<template>
    <SearchElastic
        ref="search"
        :search-context="['courses']"
        :placeholder="t('courseSelectSchool.placeholderSubject')"
        :disabled="universityId === 0"
        :filters="{ university_id: universityId }"
        option-color="text-slate-600"
        truncate
    />
</template>

<script lang="ts">
import type { VNode } from 'vue';
import { defineComponent } from 'vue';
import { useTranslation } from 'i18next-vue';

export default defineComponent({
    name: 'SelectSubjectSearch',
    props: {
        /**
         * University id
         */
        universityId: {
            type: Number,
            required: true,
            default: 0,
        },
    },
    setup() {
        const { t } = useTranslation('upload');
        return { t };
    },
    watch: {
        universityId() {
            const selectElement = this.$refs.search as VNode & {
                doSearch: () => [];
            };
            selectElement.doSearch();
        },
    },
});
</script>
